/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Draft_Keep_NamedInputs */

const en_us2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keep ${i?.name}`)
};

const pt_br2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manter ${i?.name}`)
};

const es_419_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantener ${i?.name}`)
};

const pt_pt2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manter ${i?.name}`)
};

const fr_fr2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Garder ${i?.name}`)
};

const de_de2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} behalten`)
};

const it_it2_draft_keep_named = /** @type {(inputs: Draft_Keep_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tieni ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Keep {name}" |
*
* @param {Draft_Keep_NamedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_keep_named = /** @type {((inputs: Draft_Keep_NamedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Keep_NamedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_keep_named(inputs)
	if (locale === "es-419") return es_419_draft_keep_named(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_keep_named(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_keep_named(inputs)
	if (locale === "de-DE") return de_de2_draft_keep_named(inputs)
	if (locale === "it-IT") return it_it2_draft_keep_named(inputs)
	return en_us2_draft_keep_named(inputs)
});
export { draft_keep_named as "draft.keep_named" }